'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  path: 'M21,15.6037999 L21,9.12347286 C21,9.12347286 21,6 17.898048,6 L6.1008937,6 C6.1008937,6 3,6 3,9.12347286 L3,15.6037999 C3,15.6037999 3,18.7272727 6.1008937,18.7272727 L17.898048,18.7272727 C17.898048,18.7272727 21,18.7272727 21,15.6037999 M15.4945908,12.3726945 L9.60183443,15.8574288 L9.60183443,8.88689457 L15.4945908,12.3726945',
  bgColor: '#ff0000',
  fill: '#FFFFFF',
  link: 'https://www.youtube.com/user/OLXBrasil'
};